import request from ".";

export const faqsApi = {
  getFaqsById: (id: string) =>
    request.post(`FAQs/getAllActiveFAQsBycategory?CatId=${id}`),
};
